import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Popup, Icon, Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class RestoreIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {'isOpen': false};
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleRestoreClick = this.handleRestoreClick.bind(this);
  }

  handleOpen() {
    this.setState({'isOpen': true});
  }

  handleClose() {
    this.setState({'isOpen': false});
  }

  handleRestoreClick() {
    const {order} = this.props;

    this.props.toggleDeleteMarkInSuggestedOrderElement(order);
    this.setState({'isOpen': false});
  }

  render() {
    return (
      <Popup wide inverted
        on='click'
        open={this.state.isOpen}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
        trigger={<Icon link color='blue' size='large' name='undo' />}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column textAlign='center'>
              <div>¿Desea restaurar el repuesto en el pedido?</div>
              <Button secondary
                size='mini'
                onClick={this.handleClose}
              >CANCELAR</Button>
              <Button primary
                size='mini'
                onClick={this.handleRestoreClick}
              >RESTAURAR</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Popup>
    );
  }
}

const {
  toggleDeleteMarkInSuggestedOrderElement,
  removeSuggestedOrderElement,
} = Actions;

export default connect(null, {
  toggleDeleteMarkInSuggestedOrderElement,
  removeSuggestedOrderElement,
})(RestoreIcon);
